<template><section><h1>SmoothScroll</h1>
<blockquote>
<p>平滑滚动</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<p><code>this.$smoothScroll(target, time, offset)</code></p>
<h2>Params</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>target</td>
<td style="text-align:left">目标位置，可选值<code>Number/Element</code></td>
<td><code>Number/Object</code></td>
<td><code>0</code></td>
</tr>
<tr>
<td>time</td>
<td style="text-align:left">滚动动画时间</td>
<td><code>Number</code></td>
<td><code>500</code></td>
</tr>
<tr>
<td>offset</td>
<td style="text-align:left">偏移值，一般用于target为<code>Element</code>时</td>
<td><code>Number</code></td>
<td><code>0</code></td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/SmoothScroll.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-14.vue?803b0fa0